module.exports = __webpack_public_path__ + "static/media/offer.806a6175.svg";